export default {"src":"/_next/static/media/KWD.991b94f9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};